import lottie from 'lottie-web';
import addVisibilityObserver from '@/js/components/useVisibilityObserver';
import BaseComponent from './baseComponent';

/**
 * The slider used in the newsroom to present top news, based on slick slider.
 * http://kenwheeler.github.io/slick/
 */
export default class ContentGbaSustainability extends BaseComponent {
  /**
   * Public constructor
   *
   * @param options
   */
  constructor(options) {
    super(options);
    this.els = [...document.querySelectorAll('[data-content-gba-sustainability]')];
  }

  /**
   * Initialize the slider.
   */
  init() {
    if (!this.els) {
      return;
    }

    this.els.forEach((el) => {
      this.initializeInstance(el);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  initializeInstance(el) {
    addVisibilityObserver(el, {
      onFirstEnter: () => {
        const animations = el.querySelectorAll('.animation');
        const contents = el.querySelectorAll('.item');
        const buttons = el.querySelectorAll('.button');
        let currentIndex = 0;
        let interval;
        let isPaused = false;
        const slideDuration = 5000;
        let remainingTime = slideDuration;
        let lastStartTime;

        el.style.setProperty('--content-gba-sustainability-duration', `${slideDuration}ms`);

        function addLottieAnimations() {
          animations.forEach((animation, index) => {
            const anim = lottie.loadAnimation({
              container: animation,
              renderer: 'svg',
              loop: false,
              autoplay: true,
              path: animation.dataset.animationPath,
            });

            document.addEventListener(`replay-lottie-animation-${index}`, () => {
              anim.goToAndStop(0, true);
              anim.play();
            });
          });
        }

        function playAnimation(index) {
          const event = new CustomEvent(`replay-lottie-animation-${index}`);
          document.dispatchEvent(event);
        }

        function showItem(index) {
          animations.forEach((item) => item.classList.remove('-active'));
          contents.forEach((item) => item.classList.remove('-active'));
          buttons.forEach((item) => item.classList.remove('-active'));

          requestAnimationFrame(() => {
            playAnimation(index);
          });

          animations[index].classList.add('-active');
          contents[index].classList.add('-active');
          buttons[index].classList.add('-active');

          currentIndex = index;
        }

        function showNextItem() {
          currentIndex = (currentIndex + 1) % contents.length;
          showItem(currentIndex);
          lastStartTime = Date.now(); // Log the start time of this new item display
        }

        function startCarousel() {
          lastStartTime = Date.now();
          interval = setTimeout(() => {
            showNextItem();
            // Continue regular 5-second intervals
            interval = setInterval(showNextItem, slideDuration);
          }, remainingTime);
        }

        function pauseCarousel() {
          clearTimeout(interval); // Clear any timeouts or intervals
          clearInterval(interval);
          isPaused = true;

          // Calculate remaining time by checking the elapsed
          // time since the last switch
          remainingTime = slideDuration - (Date.now() - lastStartTime);
          el.classList.add('-paused');
          // eslint-disable-next-line no-param-reassign
          el.querySelector('.pause').style.display = 'none';
          // eslint-disable-next-line no-param-reassign
          el.querySelector('.play').style.display = 'inline';
        }

        function playCarousel() {
          if (isPaused) {
            startCarousel();
            isPaused = false;
            el.classList.remove('-paused');
            // eslint-disable-next-line no-param-reassign
            el.querySelector('.pause').style.display = 'inline';
            // eslint-disable-next-line no-param-reassign
            el.querySelector('.play').style.display = 'none';
          }
        }

        el.querySelector('.pause').addEventListener('click', pauseCarousel);
        el.querySelector('.play').addEventListener('click', playCarousel);

        el.querySelectorAll('.button').forEach((button) => {
          button.addEventListener('click', () => {
            pauseCarousel();
            remainingTime = slideDuration;
            showItem(button.dataset.contentGbaSustainabilityIndex);
          });
        });

        addLottieAnimations();
        startCarousel();
      },

    }, {
      threshold: 0,
    });
  }
}
